import { forwardRef, memo, useMemo } from 'react';
import { TextProps } from './text.types';
import { StyledText } from './text.styled';

export const Text = memo(
  forwardRef<HTMLParagraphElement, TextProps>(({ children, ...props }, ref) => {
    const tag = useMemo(() => {
      if (props.variant?.includes('heading')) {
        const level = parseInt(props.variant.split('-')[1] || '2', 10);

        return `h${Math.min(level + 1, 6)}` as const;
      }

      return 'p' as const;
    }, [props.variant]);

    return (
      <StyledText ref={ref} as={tag} {...props}>
        {children}
      </StyledText>
    );
  })
);

Text.displayName = 'Text';
